/** Files picked on the landing page before the visitor has an account. They live in memory only (never in storage),
 *  follow the visitor through register/login (client-side navigation keeps the module alive) and are handed to the
 *  "Ny annonse" flow exactly once. A hard reload loses them - the flow then says so instead of failing silently. */
let files = [];
const COUNT_KEY = "magicad_pending_count";

export const setPendingFiles = (list) => {
  // HEIC from a Mac can arrive with an empty MIME type - accept by extension too
  files = Array.from(list || []).filter((f) => f && ((f.type && f.type.startsWith("image/")) || /\.(heic|heif|jpe?g|png|webp)$/i.test(f.name || "")));
  if (files.length) sessionStorage.setItem(COUNT_KEY, String(files.length)); else sessionStorage.removeItem(COUNT_KEY);
  return files.length;
};

/** The files, once. `lost` is true when a reload dropped files the visitor picked earlier. */
export const takePendingFiles = () => {
  const expected = Number(sessionStorage.getItem(COUNT_KEY) || 0);
  const f = files;
  files = [];
  sessionStorage.removeItem(COUNT_KEY);
  return { files: f, lost: expected > 0 && f.length === 0 };
};

export const pendingCount = () => files.length || Number(sessionStorage.getItem(COUNT_KEY) || 0);

const URL_KEY = "magicad_prefill_url";
export const setPendingUrl = (u) => (u ? sessionStorage.setItem(URL_KEY, u) : sessionStorage.removeItem(URL_KEY));
export const takePendingUrl = () => { const u = sessionStorage.getItem(URL_KEY) || ""; sessionStorage.removeItem(URL_KEY); return u; };
